export const TOUR_LEADER_AGENCY_ROLES = ['ITA-TRAVEL-AGENCY']

export const TOUR_LEADER_CONTENT_ADMIN_ROLES = ['ITA-DEV', 'ITA-ADMIN']

export const TOUR_LEADER_SETTINGS_ADMIN_ROLES = ['ITA-DEV', 'ITA-ADMIN']

export const TOUR_LEADER_MANAGEMENT_ROLES = [
  ...TOUR_LEADER_AGENCY_ROLES,
  ...TOUR_LEADER_CONTENT_ADMIN_ROLES,
]

// Keep discussion policy separate so it can be extended to travel agencies later
// without widening income or other content-management permissions.
export const TOUR_LEADER_DISCUSSION_ROLES = ['ITA-DEV', 'ITA-ADMIN']

export function hasAnyRole(userRoles, allowedRoles) {
  if (!Array.isArray(userRoles) || !Array.isArray(allowedRoles)) {
    return false
  }

  return userRoles.some(role => allowedRoles.includes(role))
}

// Generic Hunter communication is tenant-scoped by the server. Content admins
// may browse public profiles, but must also carry an Agency role before this UI
// can call Agency invitation, conversation, travel, or media endpoints.
export function canUseTourLeaderAgencyCommunication(userRoles) {
  return hasAnyRole(userRoles, TOUR_LEADER_AGENCY_ROLES)
}

export function canAccessTourLeaderRoute(route, userRoles) {
  const matchedRoutes = route && Array.isArray(route.matched) ? route.matched : []

  return matchedRoutes.every(routeRecord => {
    const allowedRoles = routeRecord.meta && routeRecord.meta.roles
    return !allowedRoles || hasAnyRole(userRoles, allowedRoles)
  })
}
